import _Icon from './Icon';
import _IconFont from './IconFont';

import './style/index.js';

export * from './icons';
export const Icon = _Icon;
export const IconFont = _IconFont;
